import React from 'react'
import { Row, Col } from 'antd'

import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import { WrapTotals } from './styles'

function SectionTotal({ totalSum }: { totalSum: number }) {
  return (
    <WrapTotals>
      <Row>
        <Col offset={20} span={4}>
          <Text colon id="header" title="web.report.1.data.total" />
        </Col>
      </Row>
      <Row>
        <Col offset={20} span={4}>
          <span id="value">
            {
              currencyMask({
                formatStr: true,
                precision: 2,
                value: totalSum
              }).maskedValue
            }
          </span>
        </Col>
      </Row>
    </WrapTotals>
  )
}

export default SectionTotal
